import { Component } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { Router } from '@angular/router';

/**
 * Provides an unprotected login and landing page for user and
 * developer convenience. This will be the main redirect target
 * for users who fail to authenticate with Azure and authorize
 * with the api.
 */
@Component({
    selector: 'las-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false,
})
export class LoginComponent {
    assetPath = '../../../assets/images/';

    constructor(auth: AuthService, router: Router) {
        auth.isAuthenticatedAndAuthorized().subscribe((isAuthed) => {
            // Don't let users get stuck on the login view.
            // If they're fully authed, send them to the dashboard.
            if (isAuthed) router.navigate(['/dashboard']).then(/*ignore*/);
        });
    }
}
